"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRECISION_BASE = exports.VALUE_MIN = exports.VALUE_MAX = exports.INITIAL_VALUE = exports.INITIAL_PRECISION = exports.INITIAL_ON_ELEMENT = void 0;
exports.INITIAL_ON_ELEMENT = false;
exports.INITIAL_PRECISION = 2;
exports.INITIAL_VALUE = 0;
exports.VALUE_MAX = 100;
exports.VALUE_MIN = 0;
exports.PRECISION_BASE = 10;
